import { SettingsAPI } from '@/api/settings'

import { FirebaseLoginState } from './FirebaseLoginState'
import { consoleTimeTrack } from '../../consoleTimeTrack'
import { useMemo } from 'react'

export function AuthProvider({
  needsAuth = true,
  children,
  withFirestore = true,
}) {
  useMemo(() => consoleTimeTrack('Auth wrapper component', {fileName: 'AuthProvider.jsx', methodName: 'useMemo'}), [])

  return (
    <>
      {needsAuth ? <FirebaseLoginState /> : null}
      <SettingsAPI withFirestore={withFirestore} />
      {children}
    </>
  )
}
